// extracted by mini-css-extract-plugin
export default {"youTubeEmbed":"YouTubeEmbed_youTubeEmbed__qOJI8"};